import $$ from "cmn-utils";

const baseUrl = "/api/sys/auxiliary/";
export default {
  loginCode: (query, params) => {
    let urlString = new URLSearchParams(query);
    urlString = urlString.toString();
    return $$.post(baseUrl + `sms/login-code?${urlString}`, params, {
      headers: { "content-type": "application/json" },
    });
  },
};
